/*
 * @Author: changcheng
 * @LastEditTime: 2023-11-15 15:44:05
 */
import { BannerProps, initBannerUrl } from "@root/actions/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: BannerProps = initBannerUrl;

export const userSlice = createSlice({
  name: "bannerUrl",
  initialState,
  reducers: {
    setBannerInfo: (state, action: PayloadAction<BannerProps>) => {
      state = action.payload;
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
const { actions, reducer } = userSlice;
export const { setBannerInfo } = actions;
export default reducer;
